import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomersState, customersFeatureKey } from '../reducer/customers.reducer';

export const selectCustomersState = createFeatureSelector<CustomersState>(customersFeatureKey);
export const selectCustomers = createSelector(selectCustomersState, s => s.customers);
export const selectSelectedCustomer = createSelector(selectCustomersState, s => s.selectedCustomer);
export const selectCustomersLoaded = createSelector(selectCustomersState, s => s.loaded);
export const selectCustomersLoading = createSelector(selectCustomersState, s => s.loading);
export const selectCustomersError = createSelector(selectCustomersState, s => s.error);
